import { z } from 'zod';
export const estimatingDocumentsProposalAcceptanceFactsCapability = 'estimating.documents-proposal-acceptance-facts.v1';
export const estimatingDocumentsProposalAcceptanceFactsSlot = 'documents.estimating-proposal-acceptance-facts';
export const estimatingDocumentsProposalAcceptanceFactsProviderId = 'estimating.server.documents-proposal-acceptance-facts';
export const estimatingDocumentsProposalAcceptanceFactsRequestSchema = z.strictObject({
    consumerModuleId: z.literal('documents'),
    requestedCapability: z.literal('documents.estimating-acceptance-envelopes.v1'),
    resourceType: z.literal('documents.estimating-acceptance-envelope'),
    resourceId: z.string().uuid(),
    proposalPackageId: z.string().uuid(),
    estimateId: z.string().uuid(),
    proposalEstimateVersionId: z.string().uuid(),
    expectedPresentationHash: z.string().regex(/^[a-f0-9]{64}$/),
});
export const estimatingDocumentsProposalAcceptanceFactsPresentSchema = z.strictObject({
    state: z.literal('present'),
    capability: z.literal(estimatingDocumentsProposalAcceptanceFactsCapability),
    tenantId: z.string().uuid(),
    projectId: z.string().uuid(),
    proposalPackageId: z.string().uuid(),
    proposalPresentationHash: z.string().regex(/^[a-f0-9]{64}$/),
    estimateId: z.string().uuid(),
    estimateNumber: z.string().trim().min(1).max(80),
    proposalEstimateVersionId: z.string().uuid(),
    proposalEstimateVersionContentHash: z.string().regex(/^[a-f0-9]{64}$/),
    estimateRevision: z.number().int().positive(),
    tierCode: z.enum(['standard', 'premium', 'complete']),
    title: z.string().trim().min(1).max(240),
    currencyCode: z.string().regex(/^[A-Z]{3}$/),
    totalCents: z.number().int().min(0).max(999_999_999_999),
    expiresAt: z.string().datetime({ offset: true }),
    contentHash: z.string().regex(/^[a-f0-9]{64}$/),
});
export const estimatingDocumentsProposalAcceptanceFactsNotFoundSchema = z.strictObject({
    state: z.literal('not-found'),
    capability: z.literal(estimatingDocumentsProposalAcceptanceFactsCapability),
    tenantId: z.string().uuid(),
    proposalPackageId: z.string().uuid(),
    estimateId: z.string().uuid(),
    proposalEstimateVersionId: z.string().uuid(),
    reason: z.enum(['package-not-found', 'option-not-signable', 'presentation-changed']),
});
export const estimatingDocumentsProposalAcceptanceFactsResponseSchema = z.discriminatedUnion('state', [
    estimatingDocumentsProposalAcceptanceFactsPresentSchema,
    estimatingDocumentsProposalAcceptanceFactsNotFoundSchema,
]);
//# sourceMappingURL=estimating-documents-proposal-acceptance.contract.js.map